import React, { useState, useEffect } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
  Label,
} from "recharts";
import Div from "@jumbo/shared/Div";
import { capitalizeFLetter } from "@jumbo/utils";
import { numberFormat } from "../../../utils/utils";

const LineChartBasic = ({
  reportingOverviewGraphData,
  title,
  dataKey,
  oxLabel,
  oyLabel,
  values,
  yLimit,
  labels,
  dashboardDateFilter,
  xAxis,
  interval,
  graphConfigInfo,
}) => {
  const isRightAxisMetric = (metricKey = "") =>
    metricKey == "spend" ||
    metricKey == "ctr" ||
    metricKey == "conversion_cost_gross" ||
    metricKey == "roi" ||
    metricKey.startsWith("roi_");

  const labelMap = labels.reduce((acc, label) => {
    acc[label.key] = label.displayName || label.key;
    return acc;
  }, {});
  const [barProps, setBarProps] = useState(
    labels.reduce(
      (a, { key }) => {
        a[key] = false;
        return a;
      },
      { hover: null }
    )
  );

  const [yAxis, setYAxis] = useState("available");
  const handleLegendMouseEnter = (e) => {
    // if (!barProps[e.dataKey]) {
    //   setBarProps({ ...barProps, hover: e.dataKey });
    //   setYAxis(e.dataKey);
    // }
  };

  const handleLegendMouseLeave = (e) => {
    // setBarProps({ ...barProps, hover: null });
    // setYAxis("impressions")
    // var trueKeys = Object.keys(barProps).filter(
    //   (key) => !barProps[key] && key != "hover"
    // );
    //console.log(JSON.stringify(barProps), trueKeys);
    // if (trueKeys && trueKeys.length) {
    //   setYAxis(trueKeys[0]);
    // }
  };

  useEffect(() => {
    // not availble for districts, ios_1, android_1, websites_1
    // var trueKeys = Object.keys(barProps).filter(
    //   (key) => !barProps[key] && key != "hover"
    // );
    //console.log("sidd:" + JSON.stringify(barProps), trueKeys);
    // if (trueKeys && trueKeys.length) {
    //   setYAxis(trueKeys[0]);
    // }
  }, [barProps]);

  const selectBar = (e) => {
    setBarProps({
      ...barProps,
      [e.dataKey]: !barProps[e.dataKey],
      hover: null,
    });
  };
  const legendFormatter = (value, entry) => {
    const displayName = labelMap[value] || value;
    return (
      <span>
        {displayName}{" "}
        {isRightAxisMetric(value) ? "(R)" : "(L)"}{" "}
      </span>
    );
  };
  return (
    <ResponsiveContainer
      height={
        graphConfigInfo?.containerHeight ? graphConfigInfo.containerHeight : Math.max(window.innerHeight - 500, 250)
      }
    >
      <LineChart
        width={480}
        height={
          graphConfigInfo?.lineChartHeight
            ? graphConfigInfo.lineChartHeight
            : Math.max(window.innerHeight - 500, 250)
        }
        data={reportingOverviewGraphData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: graphConfigInfo?.lineChartMarginBotton
            ? graphConfigInfo.lineChartMarginBotton
            : 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey={xAxis}
          axisLine={false}
          //tickLine={true}
          angle={
            graphConfigInfo?.xAxisLableAngle
              ? graphConfigInfo.xAxisLableAngle
              : 0
          }
          interval={interval}
          tickLine={false}
          //padding={{ left: 30, right: 30 }}
          tick={{
            textAnchor: graphConfigInfo?.lableTextAnchor
              ? graphConfigInfo.lableTextAnchor
              : "center",
          }}
          //axisLine={false}
        />
        <YAxis
          //dataKey={yAxis} //Not needed to provided data key here.. it will automatically sets the range.
          tickFormatter={numberFormat}
          axisLine={false}
          tickLine={false}
          yAxisId="left-axis"
        />
        {parseInt(
          labels.filter((obj) => isRightAxisMetric(obj.key)).length
        ) > 0 && (
          <YAxis
            yAxisId="right-axis"
            //dataKey={"spend"}
            orientation="right"
            tickFormatter={numberFormat}
            //label={{ value: "Spend", angle: 90, position: "insideRight" }}
            axisLine={false}
            tickLine={false}
          />
        )}

        <Tooltip
          content={({ active, label, payload }) => {
            return active ? (
              <Div sx={{ color: "common.white" }}>
                {payload &&
                  payload.length &&
                  payload.map((row, index) => {
                    return (
                      <div
                        key={index}
                        className={index !== payload.length - 1 ? "mb-1" : ""}
                      >
                        <div
                          style={{
                            color: row.color,
                            fontSize: 8,
                            letterSpacing: 2,
                            textTransform: "uppercase",
                          }}
                        >
                          {labelMap[row.name] || capitalizeFLetter(row.name.replace(/_/g, " "))}
                        </div>
                        <div
                          style={{
                            color: row.color,
                          }}
                        >
                          {row.value ? numberFormat(row.value) : 0}
                          {/* {row.value} */}
                        </div>
                      </div>
                    );
                  })}
              </Div>
            ) : null;
          }}
          wrapperStyle={{
            background: "white",
            borderRadius: 4,
            padding: "5px 8px",
            fontWeight: 500,
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
        />
        <Legend
          onClick={selectBar}
          //onMouseOver={handleLegendMouseEnter}
          ///onMouseOut={handleLegendMouseLeave}
          align="center"
          verticalAlign={
            graphConfigInfo?.legentAlign
              ? graphConfigInfo.legentAlign
              : "bottom"
          }
          wrapperStyle={{
            paddingBottom: "10px",
            cursor: "pointer",
            textTransform: "capitalize",
          }}
          formatter={legendFormatter}
        />
        {labels.map((label, index) => (
          <Line
            key={index}
            yAxisId={isRightAxisMetric(label.key) ? "right-axis" : "left-axis"}
            type="monotone"
            strokeWidth={2}
            dataKey={label.key}
            fill={label.color}
            stroke={label.color}
            hide={barProps[label.key] === true}
            fillOpacity={Number(
              barProps.hover === label.key || !barProps.hover ? 1 : 0.6
            )}
            filter="url(#shadow)"
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LineChartBasic;
